var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"value":_vm.value,"background-color":"transparent","color":"primary","grow":""},on:{"change":_vm.emitir}},[_c('v-tab',[_vm._v("Dia")]),_c('v-tab',[_vm._v("Ultimos 10 dias")]),_c('v-tab',[_vm._v("Periodo")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }